<template>
  <v-container fluid>
    <v-form ref="form" v-model="form" @submit.prevent="submit">
      <v-row>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-if="$root.hasAccess('can_manage_operation_amount_details')">
          <v-text-field
            label="Agency Fees Charges"
            placeholder="Enter Agency Fees Charges"
            :rules="amountRules"
            outlined
            dense
            type="number"
            v-model="serviceOptForm.amount"
            prepend-inner-icon="mdi-currency-usd"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
          <v-select
            label="Supplier"
            placeholder="Select a supplier"
            outlined
            dense
            v-model="serviceOptForm.card_id"
            prepend-inner-icon="mdi-account"
            :items="suppliers"
            :rules="[rules.required]"
            :disabled="isDisabled"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-if="$root.hasAccess('can_manage_operation_amount_details')">
          <v-select
            label="Tax"
            placeholder="Select Tax"
            outlined
            dense
            v-model="serviceOptForm.metadata.tax"
            prepend-inner-icon="mdi-cash-fast"
            :items="taxes"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
          <v-text-field
            label="Arrival immigration"
            placeholder="Arrival immigration"
            outlined
            dense
            hide-details="auto"
            v-model="serviceOptForm.metadata.arrival_immigration"
            prepend-inner-icon="mdi-passport"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
          <v-text-field
            label="Departure immigration"
            placeholder="Departure immigration"
            outlined
            dense
            hide-details="auto"
            v-model="serviceOptForm.metadata.departure_immigration"
            prepend-inner-icon="mdi-passport"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-textarea
            label="Remarks"
            placeholder="Enter Remarks"
            outlined
            dense
            hide-details
            :rows="2"
            v-model="serviceOptForm.remarks"
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="pb-0" v-if="$root.onlyAccountsCanAccess">
          <v-textarea
            label="Accounts Remarks"
            placeholder="Enter Accounts Remarks"
            outlined
            background-color="light-blue lighten-5"
            dense
            hide-details
            :rows="2"
            v-model="serviceOptForm.accounts_remarks"
            class="accounts-remarks-field"
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-btn class="float-right" color="success" outlined :disabled="loading" :loading="loading"
            @click="saveDetails">Save</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
  import rules from '../../../../utilities/validator';
  import {
    agencyFeesAmountForJobScope,
    fetchSinodaAgencyFeesCardId,
    pickAgencyFeesCardId,
  } from '../../../../utilities/agencyFeesByJobScope';

  export default {
    name: 's-services-opted-agency-fees-service',
    props: {
      operation: {
        type: Object,
        default: {},
      },
      isDraft: {
        type: Boolean,
        default: false,
      },
      servicesOpted: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        loading: false,
        form: false,
        rules,
        isDisabled: false,
        serviceOptForm: {
          service_catalog_id: null,
          card_id: null,
          amount: 0,
          remarks: '',
          accounts_remarks: '',
          bill_type: "Agency Fees",
          metadata: {
            tax: '',
            arrival_immigration: '',
            departure_immigration: '',
          }
        },
        suppliers: [],
        taxes: ['0%', '9%']
      };
    },
    methods: {
      submit() {
        return this.$refs.form.validate();
      },
      handleOperationInit() {
        this.populateSuppliers();
      },
      isAgencyFeesRow(row) {
        if (!row) return false;
        const bt = row.bill_type != null ? String(row.bill_type) : '';
        const sn = row.service_name != null ? String(row.service_name) : '';
        return bt === 'Agency Fees' || sn === 'Agency Fees';
      },
      initServiceOptedDetails() {
        const service = (this.servicesOpted || []).find((s) => this.isAgencyFeesRow(s));
        const defaultAmt = agencyFeesAmountForJobScope(this.operation?.job_scope);

        if (service) {
          this.serviceOptForm = {
            ...this.serviceOptForm,
            ...service,
            metadata: {
              ...this.serviceOptForm.metadata,
              ...(service.metadata || {}),
            },
            bill_type: 'Agency Fees',
          };
          const hasStored = service.amount != null && service.amount !== '';
          const parsed = hasStored ? parseFloat(service.amount) : NaN;
          if (hasStored && Number.isFinite(parsed)) {
            this.serviceOptForm.amount = parsed.toFixed(2);
          } else if (defaultAmt != null) {
            this.serviceOptForm.amount = defaultAmt.toFixed(2);
          }
        } else if (defaultAmt != null) {
          this.serviceOptForm.amount = defaultAmt.toFixed(2);
        }
      },
      populateSuppliers() {
        Promise.all([
          this.$api.service_catalogs.get_suppliers_list('Agency Fees'),
          fetchSinodaAgencyFeesCardId(this.$api),
        ])
          .then(([response, sinodaCardId]) => {
            this.suppliers = response.suppliers || [];
            if (this.suppliers.length > 0) {
              this.isDisabled = true;
              this.$nextTick(() => {
                const service = (this.servicesOpted || []).find((s) => this.isAgencyFeesRow(s));
                if (!service?.card_id) {
                  const id = pickAgencyFeesCardId(this.suppliers, sinodaCardId);
                  if (id != null) this.serviceOptForm.card_id = id;
                }
              });
            }
            this.serviceOptForm.service_catalog_id = response.service_catalog_id;
            this.initServiceOptedDetails();
          }).catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          });
      },
      saveDetails() {
        if(!this.submit()) return;
        this.loading = true;
        this.serviceOptForm = Object.assign(this.serviceOptForm, {
          operation_id: this.operation.id
        });
        this.$api.operation_billed_items.save_service(this.serviceOptForm)
          .then(() => {
            this.$store.dispatch('setAlert', {
              status: 'success',
              show: true,
              message: 'Agency Fees service updated successfully',
            });
          }).catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          }).finally(() => (this.loading = false));
      },
    },
    watch: {
      operation() {
        this.handleOperationInit();
      },
      servicesOpted: {
        handler() {
          if ((this.servicesOpted || []).length && this.suppliers.length) {
            this.initServiceOptedDetails();
          }
        },
        deep: true,
      },
    },
    computed: {
      amountRules() {
        if (this.isDraft || (this.operation && this.operation.is_draft)) {
          return [this.rules.required, this.rules.negative];
        } else {
          return [this.rules.negative];
        }
      },
    },
    created() {
      this.handleOperationInit();
    },
  };
</script>
